try {
  require("@rails/ujs").start()
  }catch(e){
  }
  require("../detect-ie")
  require("../attach-session-classes")
  require("../topshops/gmaps.js")
  require("../topshops/carousel")
  require("../utilities.js")
  require("../presentable.js")
  require("../present-tooltip.js")
  require("../toast.js")
  require("../videojs")
  require("../line-clamp.js")
  require("../ajax")
  require("../og-data-scraper")

window.axios = require('axios');

window.Uppy = {
  uppy: require('@uppy/core'),
  dashboard: require('@uppy/dashboard'),
  tus: require('@uppy/tus')
}

window.tus = require("tus-js-client");

window.sortablejs = require('sortablejs');
